export class HtmlBuilder {
  constructor(ids, classes, content, assets = []) {
    this.ids = ids
    this.classes = classes
    this.content = content
    this.assets = assets
  }

  build() {
    let src = this.getSource()
    let openingTag = this.getOpeningTag()
    let closingTag = this.getClosingTag()
    return `<div class="${this.classes.containerClasses}">
      ${openingTag}<img
        id="${this.ids.id}"
        alt="${this.content.alt}"
        class="wf-inline-block ${this.classes.classes}"
        src="${src}"
      />${closingTag}
    </div>`
  }

  getSource() {
    if (this.content.srcType == 'external') {
      return this.content.srcLink
    }
    return this.assets.find(asset => asset.element == 'sourceImage').image
  }

  getOpeningTag() {
    if(this.content.clickAction == 'none') {
      return ''
    }
    return `<a href="${this.imageLink()}" target="${this.content.clickTarget}">`
  }

  getClosingTag() {
    if(this.content.clickAction == 'none') {
      return ''
    }
    return `</a>`
  }

  imageLink() {
    if ( this.content.clickAction == 'external_link') {
      return this.content.link
    }

    if ( this.content.clickAction == 'image') {
      return this.getSource()
    }

    return '#lightbox'
  }
}